import React from "react";
import ReactDOM from "react-dom";
import PluxApp from "./components/PluxApp/PluxApp";
import "./styles/styles.scss";

const app = document.getElementById("app");

ReactDOM.render(<PluxApp />, app);



// WEBPACK FOOTER //
// ./src/index.js